/* src\svelte\SearchBar.html generated by Svelte v1.64.1 */
import { addListener, appendNode, assign, createElement, createText, destroyEach, detachNode, init, insertNode, noop, proto, removeListener, setAttribute } from "svelte/shared.js";

function apiUrl(apiEndpoint, keyword) {
    return `${apiEndpoint}?keyword=${keyword}`;
};

function hasEnoughChars( keyword ) {
    return keyword.length >= 2;
};

function data() {
    return {
        // Public
        placeHolder: "Search"
        , apiEndpoint: ""
        , results: []
				, searchUrl: ""

        // Private
				, wg: "searchBar"
        , keyword: ""
        , isResultsHidden: true
    };
};

var methods = {

    handleOnClick(event) {
        event.stopPropagation();
        this.set({ isResultsHidden: false });
    },

			handleOnSubmit(event) {
				event.stopPropagation();
				const {searchUrl, keyword} = this.get();
				window.location.href = `${searchUrl}?keyword=${keyword}`;
			},

    updateList(event) {
				const keyCode = event.keyCode;
				const {keyword, apiUrl, hasEnoughChars} = this.get();

				keyCode == 13 ? this.handleOnSubmit(event) :

        hasEnoughChars ?

					fetch(apiUrl).then(response => {
						// Convert to JSON
						return response.json();
					}).then(json => {
						const data = json.Results;

						let dataTransformed = [];
						data.forEach(item => {
							let newItem = item;
							const index = newItem.Title.toLowerCase().indexOf(keyword.toLowerCase());
							const length = keyword.length;
							if(index >= 0) {
								const replaceStr = newItem.Title.substring(index, index + length);
								newItem.Title = newItem.Title.replace(replaceStr, `<strong>${replaceStr}</strong>`);
							}
							dataTransformed.push(newItem);
						});
						this.set({
							results: dataTransformed,
							isResultsHidden: false
						});

					}).catch(err => {
						console.log(`SearchBar: No Results found`)
					})

					: this.set({
					 	results: [],
						isResultsHidden: true
					});
    }
};

function create_main_fragment(component, state) {
	var div, div_1, div_2, div_3, button, button_class_value, div_3_class_value, text_2, input, input_updating = false, input_class_value, text_3, div_4, div_4_class_value, text_7, div_5, div_5_class_value;

	function onwindowclick(event) {
		component.set({ isResultsHidden: true });
	}
	window.addEventListener("click", onwindowclick);

	function click_handler(event) {
		component.handleOnSubmit(event);
	}

	function input_input_handler() {
		input_updating = true;
		component.set({ keyword: input.value });
		input_updating = false;
	}

	function keyup_handler(event) {
		component.updateList(event);
	}

	function touchend_handler(event) {
		component.updateList(event);
	}

	var each_value = state.results;

	var each_blocks = [];

	for (var i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(component, assign(assign({}, state), {
			each_value: each_value,
			result: each_value[i],
			result_index: i
		}));
	}

	return {
		c: function create() {
			div = createElement("div");
			div_1 = createElement("div");
			div_2 = createElement("div");
			div_3 = createElement("div");
			button = createElement("button");
			button.innerHTML = "<span class=\"icon-search\"></span>";
			text_2 = createText("\r\n\t\t\t");
			input = createElement("input");
			text_3 = createText("\r\n\t\t\t");
			div_4 = createElement("div");

			for (var i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			text_7 = createText("\r\n\t");
			div_5 = createElement("div");
			div_5.innerHTML = "<span class=\"icon-close\"></span>";
			this.h();
		},

		h: function hydrate() {
			addListener(button, "click", click_handler);
			button.className = button_class_value = "" + state.wg + "-btnSearch";
			button.type = "button";
			div_3.className = div_3_class_value = "" + state.wg + "-search";
			addListener(input, "input", input_input_handler);
			addListener(input, "keyup", keyup_handler);
			addListener(input, "touchend", touchend_handler);
			input.className = input_class_value = "" + state.wg + "-input";
			setAttribute(input, "type", "text");
			input.placeholder = state.placeHolder;
			div_4.className = div_4_class_value = "" + state.wg + "-results " + (state.isResultsHidden ? '' : 'has-results');
			div_2.className = "col-12 col-lg-6";
			div_1.className = "row justify-content-center";
			div_5.className = div_5_class_value = "" + state.wg + "-close toggle-searchBar";
			div.className = "container position-relative";
		},

		m: function mount(target, anchor) {
			insertNode(div, target, anchor);
			appendNode(div_1, div);
			appendNode(div_2, div_1);
			appendNode(div_3, div_2);
			appendNode(button, div_3);
			appendNode(text_2, div_2);
			appendNode(input, div_2);

			input.value = state.keyword;

			appendNode(text_3, div_2);
			appendNode(div_4, div_2);

			for (var i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(div_4, null);
			}

			appendNode(text_7, div);
			appendNode(div_5, div);
		},

		p: function update(changed, state) {
			if ((changed.wg) && button_class_value !== (button_class_value = "" + state.wg + "-btnSearch")) {
				button.className = button_class_value;
			}

			if ((changed.wg) && div_3_class_value !== (div_3_class_value = "" + state.wg + "-search")) {
				div_3.className = div_3_class_value;
			}

			if (!input_updating) input.value = state.keyword;
			if ((changed.wg) && input_class_value !== (input_class_value = "" + state.wg + "-input")) {
				input.className = input_class_value;
			}

			if (changed.placeHolder) {
				input.placeholder = state.placeHolder;
			}

			var each_value = state.results;

			if (changed.wg || changed.results) {
				for (var i = 0; i < each_value.length; i += 1) {
					var each_context = assign(assign({}, state), {
						each_value: each_value,
						result: each_value[i],
						result_index: i
					});

					if (each_blocks[i]) {
						each_blocks[i].p(changed, each_context);
					} else {
						each_blocks[i] = create_each_block(component, each_context);
						each_blocks[i].c();
						each_blocks[i].m(div_4, null);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].u();
					each_blocks[i].d();
				}
				each_blocks.length = each_value.length;
			}

			if ((changed.wg || changed.isResultsHidden) && div_4_class_value !== (div_4_class_value = "" + state.wg + "-results " + (state.isResultsHidden ? '' : 'has-results'))) {
				div_4.className = div_4_class_value;
			}

			if ((changed.wg) && div_5_class_value !== (div_5_class_value = "" + state.wg + "-close toggle-searchBar")) {
				div_5.className = div_5_class_value;
			}
		},

		u: function unmount() {
			detachNode(div);

			for (var i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].u();
			}
		},

		d: function destroy() {
			window.removeEventListener("click", onwindowclick);

			removeListener(button, "click", click_handler);
			removeListener(input, "input", input_input_handler);
			removeListener(input, "keyup", keyup_handler);
			removeListener(input, "touchend", touchend_handler);

			destroyEach(each_blocks);
		}
	};
}

// (18:4) {{#each results as result}}
function create_each_block(component, state) {
	var result = state.result, each_value = state.each_value, result_index = state.result_index;
	var div, span, span_class_value, text, a, raw_value = result.Title, a_href_value, div_class_value;

	return {
		c: function create() {
			div = createElement("div");
			span = createElement("span");
			text = createText("\r\n\t\t\t\t\t\t");
			a = createElement("a");
			this.h();
		},

		h: function hydrate() {
			span.className = span_class_value = "" + state.wg + "-resultIcon icon-search mr-2";
			a.href = a_href_value = result.Url;
			div.className = div_class_value = "" + state.wg + "-result";
		},

		m: function mount(target, anchor) {
			insertNode(div, target, anchor);
			appendNode(span, div);
			appendNode(text, div);
			appendNode(a, div);
			a.innerHTML = raw_value;
		},

		p: function update(changed, state) {
			result = state.result;
			each_value = state.each_value;
			result_index = state.result_index;
			if ((changed.wg) && span_class_value !== (span_class_value = "" + state.wg + "-resultIcon icon-search mr-2")) {
				span.className = span_class_value;
			}

			if ((changed.results) && raw_value !== (raw_value = result.Title)) {
				a.innerHTML = raw_value;
			}

			if ((changed.results) && a_href_value !== (a_href_value = result.Url)) {
				a.href = a_href_value;
			}

			if ((changed.wg) && div_class_value !== (div_class_value = "" + state.wg + "-result")) {
				div.className = div_class_value;
			}
		},

		u: function unmount() {
			a.innerHTML = '';

			detachNode(div);
		},

		d: noop
	};
}

function SvelteComponent(options) {
	init(this, options);
	this._state = assign(data(), options.data);
	this._recompute({ apiEndpoint: 1, keyword: 1 }, this._state);

	this._fragment = create_main_fragment(this, this._state);

	if (options.target) {
		this._fragment.c();
		this._mount(options.target, options.anchor);
	}
}

assign(SvelteComponent.prototype, proto);
assign(SvelteComponent.prototype, methods);

SvelteComponent.prototype._recompute = function _recompute(changed, state) {
	if (changed.apiEndpoint || changed.keyword) {
		if (this._differs(state.apiUrl, (state.apiUrl = apiUrl(state.apiEndpoint, state.keyword)))) changed.apiUrl = true;
	}

	if (changed.keyword) {
		if (this._differs(state.hasEnoughChars, (state.hasEnoughChars = hasEnoughChars(state.keyword)))) changed.hasEnoughChars = true;
	}
}
export default SvelteComponent;